import { inject, Injector, runInInjectionContext } from '@angular/core';
import { TextService } from '@service/text/text.service';
import { ActivatedRoute, Router, ActivatedRouteSnapshot } from '@angular/router';

export abstract class BaseConfigurableComponent {
  protected textService = inject(TextService);
  protected route = inject(ActivatedRoute);
  private theRouter = inject(Router);
  private injector = inject(Injector);
  
  public branch: string = ''
  public origin: string = ''

  public early: string = ''
  public late: string = ''

  public isKiosk: boolean = false

  deepLink = {
    serv: -1,
    staff: ''
  }
  
  textKey;

  constructor(textGroupKey: string) {
    this.textKey = textGroupKey
    this.initializeComponent();
  }

  private initializeComponent(): void {
    this.getOrigin();
  }

  getOrigin() {
    //https://www.youtube.com/watch?v=xyKT0AMN25A
    this.route.queryParams.subscribe(params => {
      const selectedBranch = document.cookie
      const match = selectedBranch.match(/selectedBranch=([^;]+)/);

      this.branch = match ? match[1] : ''
      
      this.origin = params['origin']
      
      this.early = params['early']
      this.late = params['late']

      if(params['staff'])
        this.deepLink.staff = params['staff']

      if(params['serv'])
        this.deepLink.serv = params['serv']


      if (this.branch != '' && this.origin != undefined) {
        this.isKiosk = true;
        
        if (this.textKey !== 'modal') {
          this.setupTimeoutForKiosk();
        } 
      } 
    });
  }

  private setupTimeoutForKiosk(): void {
    const currentUrl = this.theRouter.url;

    if (this.isKiosk && !currentUrl.startsWith('/splash')) {

      const currentInjector = this.injector;
      
      import('@app/services/timeout/timeout.service').then(module => {
        const TimeoutService = module.TimeoutService;
        
        runInInjectionContext(currentInjector, () => {
          const timeoutService = inject(TimeoutService);
          const router = inject(Router);
      
          const currentRoute = this.findDeepestRoute(router.routerState.snapshot.root);
          
          if (currentRoute) {
            const currentTimeout = currentRoute.data['timeout'];

          const path = '/splash';

          const queryString = `?origin=kiosk&branch=${this.branch}`;

          const finalUrl = `${path}${queryString}`;

          const defaultAction = finalUrl;

            if (!currentTimeout) {
              const defaultTimeout = 60;
               
              currentRoute.data = { 
                ...currentRoute.data, 
                timeout: defaultTimeout, 
                timeoutAction: defaultAction 
              };
              timeoutService.restartTimeoutTimer();
            } else {
              currentRoute.data = {
                ...currentRoute.data,
                timeoutAction: defaultAction
              };
              timeoutService.restartTimeoutTimer();
            }
          } 
        });
      })
    }
  }

  private findDeepestRoute(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot | null {
    return route?.firstChild ? this.findDeepestRoute(route.firstChild) : route;
  }

  getText() {
    return this.textService.getText()[this.textKey]
  }
}